import styled, { keyframes } from 'styled-components'
import { Th, Td, TdButtons, BulkHeaderLine, BulkHeaderTd } from '../styles/table-style'

export { BulkHeaderLine, BulkHeaderTd }

export const TableArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  position: relative;
`

export const TableToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.35rem;
`

export const ToolbarSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 0;
`

export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
  flex-shrink: 0;
`

export const TableScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  width: 100%;
  padding-right: 10px;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #696969;
    border-radius: 10px;
  }
`

export const ColumnsWrapper = styled.div`
  position: relative;
  margin-left: auto;
`

export const HeaderExportButton = styled.button`
  font-weight: bold;
  user-select: none;
  display: flex;
  gap: 0.4rem;
  height: 2rem;
  align-items: center;
  font-size: 0.72rem;
  padding: 0 0.9rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090d3;
  border: none;
  border-radius: 2rem;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 2rem;
  padding: 0 0.8rem;
  border: 1px solid #d9d9d9;
  border-radius: 0.5rem;
  background-color: #fff;
  color: #696969;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    border-color: #0090d3;
    color: #0090d3;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`

export const ColumnsButton = styled.button<{ $iconOnly?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 2rem;
  padding: ${(props) => (props.$iconOnly ? '0 0.5rem' : '0 0.8rem')};
  border: 1px solid #d9d9d9;
  border-radius: 0.5rem;
  background-color: #fff;
  color: #696969;
  font-size: 0.72rem;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0090d3;
    color: #0090d3;
  }
`

export const ColumnsPopover = styled.div`
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  width: 19rem;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 0.6rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 30;
  padding: 0.8rem;
  box-sizing: border-box;
`

export const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.6rem;
`

export const PopoverTitle = styled.span`
  font-size: 0.78rem;
  font-weight: 700;
  color: #333;
`

export const RestoreButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  border: none;
  background: none;
  color: #0090d3;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  white-space: nowrap;

  &:hover {
    background-color: #e6f4fb;
  }
`

export const ColumnsSearchInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 0.4rem;
  padding: 0.4rem 0.6rem;
  font-size: 0.72rem;
  margin-bottom: 0.5rem;
  outline: none;

  &:focus {
    border-color: #0090d3;
  }
`

export const ColumnsList = styled.div`
  max-height: 18rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const ColumnRow = styled.div<{ $dragging?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.4rem;
  border-radius: 0.4rem;
  font-size: 0.74rem;
  color: #333;
  background-color: ${(props) => (props.$dragging ? '#e6f4fb' : 'transparent')};

  &:hover {
    background-color: #f5f5f5;
  }
`

export const DragHandle = styled.span`
  display: inline-flex;
  color: #bdbdbd;
  cursor: grab;
  flex-shrink: 0;
`

export const TreeConnector = styled.span<{ $isLast?: boolean }>`
  position: relative;
  width: 12px;
  align-self: stretch;
  flex-shrink: 0;
  margin-left: 1.8rem;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: -7px;
    bottom: ${(props) => (props.$isLast ? '50%' : '-7px')};
    width: 1px;
    background-color: #cfcfcf;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 12px;
    height: 1px;
    background-color: #cfcfcf;
  }
`

export const ColumnCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 15px;
  height: 15px;
  accent-color: #0090d3;
  cursor: pointer;
  flex-shrink: 0;
`

export const ColumnName = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;
`

export const ArrowGroup = styled.div`
  display: flex;
  gap: 2px;
  flex-shrink: 0;
`

export const ArrowButton = styled.button`
  border: none;
  background: none;
  color: #bdbdbd;
  cursor: pointer;
  display: inline-flex;
  padding: 2px;
  border-radius: 3px;

  &:hover:not(:disabled) {
    color: #0090d3;
    background-color: #e6f4fb;
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`

export const SortableTh = styled(Th)<{ $sortable?: boolean }>`
  cursor: ${(props) => (props.$sortable ? 'pointer' : 'default')};
  user-select: none;
`

export const ActionsTh = styled(Th)`
  text-align: center;
  padding: 0 0.75rem;
  width: 1%;
  white-space: nowrap;
`

export const ActionsTd = styled(Td)`
  text-align: center;
  vertical-align: middle;
  width: 1%;
  max-width: none;
  padding: 0 0.75rem;
  white-space: nowrap;

  > div {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`

export const GearTh = styled(Th)`
  padding: 0 0.75rem;
  width: 1%;
  text-align: center;
  white-space: nowrap;
`

export const GearTd = styled(Td)`
  width: 1%;
  max-width: none;
  padding: 0;
`

export const ThContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MutedSortIcon = styled.span`
  display: inline-flex;
  opacity: 0.3;
`

export const ActiveSortIcon = styled.span`
  display: inline-flex;
  color: #0090d3;
`

export const ExpandCellContent = styled.div<{ $depth?: number }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: ${(props) => (props.$depth ? `${props.$depth * 1.1}rem` : '0')};
`

export const ExpandToggle = styled.button`
  border: none;
  background: none;
  color: #0090d3;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 3px;
  flex-shrink: 0;

  &:hover {
    background-color: #e6f4fb;
  }
`

export const EmptyMessage = styled.div`
  padding: 2rem;
  text-align: center;
  font-size: 0.8rem;
  color: #696969;
`

const spinAnimation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(1px);
  z-index: 20;
`

export const LoadingSpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #e6f4fb;
  border-top-color: #0090d3;
  border-radius: 50%;
  animation: ${spinAnimation} 0.8s linear infinite;
`

export const LoadingText = styled.span`
  font-size: 0.76rem;
  font-weight: 600;
  color: #0090d3;
`
